<button (click)="select.emit(color)" [class.active]="active" class="color-wrap">
  <div [style.background-color]="color" class="color">
    <fa-icon [class.hidden]="iconHidden" [icon]="icon" [fixedWidth]="true"></fa-icon>
  </div>
</button>
